import encode64 from "../helpers/encode64";
import consultarInfoToken from "./consultarInfoToken";
import getDatos from "./getDatos";

export default async function pathComponents() {
  const objectArrayPath = [];
  let infoToken = await consultarInfoToken();
  const data = await getDatos("atributos/componentes", {
    info: encode64(JSON.stringify(infoToken)),
  });
  for (let i = 0; i < data.length; i++) {
    objectArrayPath.push({
      id_componente: data[i].id_componente,
      nombre_componente: data[i].nombre_componente,
      url: data[i].url_componente,
      fraseCorta: data[i].frase_corta,
      descripcion: data[i].descripcion,
      imagen: data[i].imagen,
    });
  }
  return objectArrayPath;
}
